/**
 * Auth API service file
 *
 * @package    src/services
 * @author     DongTuring <dong@turing.com>
 * @copyright  2018 Turing Company
 * @license    Turing License
 * @version    2.0
 * @link       https://turing.ly
 */
import axios from 'axios'
import { store } from '../../shared/ConfigureStore';
import history from './history';
import { ApiConstant, PageConstant } from '../constants'
import AuthActions from '../../actions/Auth';

/**
 * API description
 *
 * @author  DongTuring <dong@turing.com>
 * @param   string   email      user's email address
 * @param   string   password   user's email address
 * @return  object              
 */
export function signup(formData) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token 
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SIGNUP, formData, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SIGNUP, formData)  
  }
}

/**
 * Login with email and password 
 *
 * @author  DongTuring <dong@turing.com>
 * @param   string   email      user's email address
 * @param   string   password   user's email address
 * @return  object              
 */
export function login(formData) {
  return axios.post(ApiConstant.BASE_URL + ApiConstant.SIGNIN, formData)
}

/**
 * Log for signup or login with social
 */
export function log4Social(formData) {
  return axios.post(ApiConstant.BASE_URL + ApiConstant.LOG_FOR_SOCIAL, formData)
}

/**
 * Login with id and password for admin
 *
 * @author  DongTuring <dong@turing.com>
 * @param   string   id      user's id
 * @param   string   password   user's email address
 * @return  object              
 */
export function loginForAdmin(formData) {
  return axios.post(ApiConstant.BASE_URL + ApiConstant.SIGNIN_ADMIN, formData)
}

/**
 * Login with Google SSO for admin
 *
 * @author  Wassim <wassim.b@turing.com>
 */
 export function loginForAdminSSO (formData) {
  return axios.post(ApiConstant.BASE_URL + ApiConstant.SIGNIN_ADMIN_SSO, formData);
}

/**
 * Login with Google account
 *
 * @author  DongTuring <dong@turing.com>
 * @return  object              
 */
export function loginWithGoogle(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token 
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SIGNIN_GOOGLE, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SIGNIN_GOOGLE, data)
  }
}

/**
 * Save Google account
 *
 * @author  DongTuring <dong@turing.com>
 * @return  object              
 */
export function saveGoogleData(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token 
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_GOOGLE, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_GOOGLE, data)
  }
}

/**
 * Save Google account
 *
 * @author  DongTuring <dong@turing.com>
 * @return  object              
 */
export function saveGoogleFailedStatus(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token 
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_GOOGLE_FAILED, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_GOOGLE_FAILED, data)
  }
}

/**
 * Login with Facebook account
 *
 * @author  YingTuring <ying@turing.com>
 * @return  object              
 */
export function loginWithFacebook(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token 
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SIGNIN_FACEBOOK, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SIGNIN_FACEBOOK, data)
  }
}

/**
 * Save facebook account data
 *
 * @author  YingTuring <ying@turing.com>
 * @return  object              
 */
export function saveFacebookData(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token 
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_FACEBOOK, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_FACEBOOK, data)
  }
}

/**
 * Save facebook account data
 *
 * @author  DongTuring <dong@turing.com>
 * @return  object              
 */
export function saveFacebookFailedStatus(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token 
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_FACEBOOK_FAILED, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_FACEBOOK_FAILED, data)
  }
}

/**
 * Save facebook account data
 *
 * @author  DongTuring <dong@turing.com>
 * @return  object              
 */
export function sendEmail(data) {
  
  return axios.post(ApiConstant.BASE_URL + ApiConstant.SEND_FORGOT_PASS_EMAIL, data)
  
}

/**
 * Reset password account data
 *
 * @author  DongTuring <dong@turing.com>
 * @return  object              
 */
export function resetPass(data) {
  
  return axios.post(ApiConstant.BASE_URL + ApiConstant.RESET_PASS, data)
  
}

/**
 * Get email from token
 *
 * @author  Salman <salman.t@turing.com>
 * @return  object
 */
export function getEmailFromToken(data) {

  return axios.post(ApiConstant.BASE_URL + ApiConstant.GET_EMAIL_FROM_TOKEN, data)

}

/**
 * Get redirect url base on the token
 *
 * @author  DongTuring <dong@turing.com>
 * @param   string   token 
 * @return  string   redirect url 
 */
export function getRedirectUrl(token) {
  var header = {
    'Content-Type': 'application/json',
    'Authorization': token || localStorage.getItem('token')
  }
  
  return axios.get(ApiConstant.BASE_URL + ApiConstant.GET_REDIRECT_URL, { headers: header })
}

/**
 * Get redirect url base on mail token
 *
 * @author  DongTuring <dong@turing.com>
 * @param   string   token 
 * @return  string   redirect url 
 */
export function getRedirectUrlFromMailToken(token, type, templateInfo) {
  let data = {
    token: token,
    type: type,
    templateInfo: templateInfo
  }

  return axios.post(ApiConstant.BASE_URL + ApiConstant.GET_MAIL_REDIRECT_URL, data)
}

/**
 * Unsubscribe mail client
 *
 * @author  DongTuring <dong@turing.com>
 * @param   string   token 
 * @return  string   redirect url 
 */
export function unsubscribe(data) {
  return axios.post(ApiConstant.BASE_URL + ApiConstant.UNSUBSCRIBE, data)
}

/**
 * Unsubscribe from turing emails
 *
 * @author  Zecharias <zecharias.a@turing.com>
 * @param   string   token 
 * @return  string   redirect url 
 */
export function unsubscribeFromTuringEmails(data) {
  return axios.post(ApiConstant.BASE_URL + ApiConstant.UNSUBSCRIBE_TURING_EMAIL, data)
}

/**
 * logout
 *
 * @author  DongTuring <dong@turing.com>
 * @param   string   token 
 * @return  string   redirect url 
 */
export function logout(data) {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token 
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.LOGOUT, data, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.LOGOUT, data)
  }
}

/**
 * Check admin token
 *
 * @author  DongTuring <dong@turing.com>
 * @param   
 * @return  object              
 */
export function checkAdminValidation() {
  var token = localStorage.getItem('adminToken')
  var header = {
    'Content-Type': 'application/json',
    'authorization': token
  }

  return axios.get(ApiConstant.BASE_URL + ApiConstant.CHECK_ADMIN_TOKEN_VALIDATION, { headers: header })
}

export const saveUserEntranceInfo = async (data) => {
  var token = localStorage.getItem('token')
  var header

  if (token) {
    header = {
      'Content-Type': 'application/json',
      'Authorization': token 
    }
    return axios.post(ApiConstant.BASE_URL + ApiConstant.SAVE_USER_ENTRANCE, {
      entranceData: data
    }, { headers: header })
  } else {
    return axios.post(ApiConstant.BASE_URL + ApiConstant.LOGOUT, data)
  }
}

export const redirectUser = async (forceUrl = null, defaultURL = PageConstant.DASHBOARD_DEV) => {
  store.dispatch(AuthActions.checkingRedirection(true))
  const isInternalUrl = (url) => {
    return url.startsWith('/');
  };

  const handleRedirection = (url) => {
    if (isInternalUrl(url)) {
      history.push(url); // Use history.push for internal URLs
    } else {
      window.location.href = url; // Use window.location.href for external URLs
    }
  };
  try {
    if (forceUrl) {
      store.dispatch(AuthActions.checkingRedirection(false))
      handleRedirection(forceUrl)
      return;
    } 
    const response = await getRedirectUrl();
    store.dispatch(AuthActions.checkingRedirection(false))
    if (response && response.data && response.data.code && response.data.code === 200) {
      handleRedirection(response.data.data.url)
    } else {
      handleRedirection(defaultURL)
    }
  } catch (error) {
    // Handle errors if necessary
    store.dispatch(AuthActions.checkingRedirection(false))
    console.error("Error fetching redirect URL:", error);
    handleRedirection(defaultURL)
  }
}